import React from "react";

import { FeedbackTopBanner } from "./FeedbackTopBanner";

export const FeedbackFormLayout = ({ title, subtitle, children }) => {
  return (
    <>
      <FeedbackTopBanner title={title} subtitle={subtitle} />
      <div>
        {children}
      </div >
    </>
  );
};

